<template>
  <div class="admin-container">
    <el-container>
      <el-header class="admin-header">
        <div class="header-left">
          <h1>博客管理后台</h1>
        </div>
        <div class="header-right">
          <el-button @click="logout">退出登录</el-button>
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px" class="admin-sidebar">
          <el-menu :default-active="activeMenu" class="sidebar-menu" mode="vertical">
            <el-menu-item index="articles" @click="$router.push('/admin/articles')">
              <i class="el-icon-document"></i>
              <span>文章管理</span>
            </el-menu-item>
            <el-menu-item index="categories" @click="$router.push('/admin/categories')">
              <i class="el-icon-folder-opened"></i>
              <span>分类管理</span>
            </el-menu-item>
            <el-menu-item index="tags" @click="$router.push('/admin/tags')">
              <i class="el-icon-tags"></i>
              <span>标签管理</span>
            </el-menu-item>
            <el-menu-item index="comments" @click="$router.push('/admin/comments')">
              <i class="el-icon-chat-dot-round"></i>
              <span>评论管理</span>
            </el-menu-item>
            <el-menu-item index="users" @click="$router.push('/admin/users')">
              <i class="el-icon-user"></i>
              <span>用户管理</span>
            </el-menu-item>
            <el-menu-item index="config" @click="$router.push('/admin/config')">
              <i class="el-icon-setting"></i>
              <span>系统配置</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main class="admin-content">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Admin',
  data() {
    return {
      activeMenu: this.$route.path.replace('/admin/', '') || 'articles'
    }
  },
  watch: {
    '$route.path': function(newPath) {
      this.activeMenu = newPath.replace('/admin/', '') || 'articles'
    }
  },
  methods: {
    logout() {
      sessionStorage.removeItem('admin_logged')
      this.$router.push('/admin/login')
    }
  }
}
</script>

<style scoped>
.admin-container {
  min-height: 100vh;
}

.admin-header {
  background: #2d3748;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.header-left h1 {
  margin: 0;
  font-size: 18px;
}

.admin-container > .el-container {
  height: calc(100vh - 60px);
}

.admin-sidebar {
  background: #4a5568;
  height: 100%;
}

.sidebar-menu {
  border-right: none;
  height: 100%;
}

.sidebar-menu .el-menu-item {
  color: #e2e8f0;
}

.sidebar-menu .el-menu-item.is-active {
  background: #2d3748;
  color: #63b3ed;
}

.el-menu{
 background: #2d3748 !important;
}

.admin-content {
  padding: 20px;
  background: #f7fafc;
}
</style>
